import React from 'react';
import { motion } from 'framer-motion';
import { Lock, CreditCard, ShieldCheck } from 'lucide-react';
import { goToCheckout } from '../utils/checkout';
export function ValueStack() {
  return <section id="pricing" className="py-24 px-4 relative bg-brand-dark" data-id="element-193">
      <div className="absolute inset-0 bg-radial-glow opacity-40 pointer-events-none" data-id="element-194" />

      <div className="max-w-3xl mx-auto relative z-10" data-id="element-195">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="bg-brand-darker border-2 border-brand-orange rounded-2xl p-8 md:p-12 shadow-[0_0_50px_rgba(255,81,0,0.15)]" data-id="element-196">
          <h2 className="text-3xl md:text-4xl font-bold text-white uppercase text-center mb-2" data-id="element-197">
            Acceso al Protocolo Alpha
          </h2>
          <p className="text-brand-muted text-center text-lg mb-10" data-id="element-198">
            El manual completo de reprogramación neuro-hormonal en versión
            digital.
          </p>

          <div className="text-center border-y border-brand-gray py-8 mb-8" data-id="element-199">
            <p className="text-white font-bold text-2xl uppercase mb-4" data-id="element-200">
              Precio Hoy:
            </p>
            <div className="flex justify-center items-start mb-2" data-id="element-201">
              <span className="text-3xl md:text-5xl font-bold text-brand-orange mt-2" data-id="element-202">
                $
              </span>
              <span className="text-7xl md:text-9xl font-display font-bold text-brand-orange leading-none" data-id="element-203">
                6.36
              </span>
            </div>
            <p className="text-brand-orange font-bold uppercase tracking-wider" data-id="element-204">
              Un solo pago. Acceso inmediato.
            </p>
          </div>

          <button onClick={goToCheckout} className="w-full bg-brand-orange hover:bg-[#ff6a26] text-white font-display font-bold text-2xl md:text-3xl py-6 px-8 rounded-sm transition-all transform hover:scale-105 shadow-[0_0_30px_rgba(255,81,0,0.5)] uppercase tracking-wide mb-6" data-id="element-205">
            Sí, quiero el acceso por $6.36
          </button>

          <div className="flex flex-wrap justify-center items-center gap-6 text-brand-muted text-sm" data-id="element-206">
            <div className="flex items-center gap-2" data-id="element-207">
              <Lock className="w-4 h-4" data-id="element-208" />
              <span data-id="element-209">Pago 100% Seguro</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-210">
              <CreditCard className="w-4 h-4" data-id="element-211" />
              <span data-id="element-212">Tarjetas / PayPal</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-213">
              <ShieldCheck className="w-4 h-4" data-id="element-214" />
              <span data-id="element-215">Garantía de 7 días</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}